import { CategorySidebar } from "../../components/CategorySidebar";
import SliderBar from "../../components/SliderBar";
import BannerList from "../../components/BannerList";

export default function BannerHome() {
  return (
    <section className="relative overflow-hidden bg-gradient-to-r from-slate-950 via-slate-900 to-indigo-950 text-white">
      <div className="absolute inset-0 pointer-events-none opacity-60">
        <div className="absolute -left-10 top-10 h-64 w-64 rounded-full bg-sky-500/20 blur-3xl" />
        <div className="absolute right-0 bottom-0 h-72 w-72 rounded-full bg-indigo-500/30 blur-3xl" />
      </div>

      <div className="hero-grid relative z-10 mx-auto max-w-7xl px-4 py-10 lg:py-14">

        <div className=" grid gap-6 lg:grid-cols-[280px,1fr,260px] items-start">
          <CategorySidebar />

<div className="glass-card min-h-[320px] border border-white/10 bg-white/5  shadow-2xl w-full max-w-full overflow-hidden">

            <SliderBar />
          </div>



          <div className="flex flex-col gap-4">
            <BannerList />
          </div>
        </div>
      </div>
    </section>
  );
}
